<template>
  <form class="information-form" @submit.prevent="handleSubmit" v-if="data.content.length">
    <div class="declare" v-if="data.note">{{ data.note }}</div>
    <div class="form-container">
      <div class="form-content">
        <div class="form-content-item" v-for="(item, index) in data.content" :key="item.id">
          <!-- 单行文本 -->
          <div class="input-line" v-if="item.type === 1">
            <div class="fields">
              <label :for="item.apiName">{{ item.name }}<span class="required" v-if="item.required">*</span></label>
            </div>
            <input type="text" :id="item.apiName" :name="item.apiName" placeholder="请输入"
              :class='["input", "input-single", { "input-error": item.error && !item.value }]' autocomplete="off"
              @blur="blur(item, index)" @focus="focus(item, index)" v-model="item.value" maxlength="100" />
            <span class="clear-btn" v-if="item.value && item.isFocus" @click="clearText(item, index)"></span>
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
          <!-- 多行文本 -->
          <div class="item-textarea" v-else-if="item.type === 2">
            <div class="fields">
              <label :for="item.apiName">{{ item.name }}<span class="required" v-if="item.required">*</span></label>
            </div>
            <textarea :maxlength="item.maxLength || 1000" :name="item.apiName" :id="item.apiName"
              @blur="checkFormItem(item, index)" :class='["textarea", { "input-error": item.error }]' placeholder="请输入"
              v-model="item.value">
              </textarea>
            <span class="count-num">{{ item.value.length }}/{{ item.maxLength || 1000 }}</span>
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
          <!-- 数字 -->
          <div class="input-line" v-else-if="item.type === 3">
            <div class="fields">
              <label :for="item.apiName">{{ item.name }}<span class="required" v-if="item.required">*</span></label>
            </div>
            <input type="number" step="0.01" :id="item.apiName"
              :name="item.apiName" placeholder="请输入" @blur="blur(item, index)"
              @focus="focus(item, index)" :class='["input", "input-single", { "input-error": item.error }]'
              v-model="item.value" />
            <div class="error" v-if="item.error">{{ item.error }}</div>
            <span class="clear-btn" v-if="item.value && item.isFocus" @click="clearText(item, index)"></span>
          </div>
          <!-- 日期 -->
          <div v-else-if="item.type === 4">
            <div class="fields">
              <label :for="item.apiName">{{ item.name }}<span class="required" v-if="item.required">*</span></label>
            </div>
            <input :id="item.apiName" v-model="item.value" type="date" :name="item.apiName" placeholder="请选择日期"
              :class='[{ "input-error": item.error }, { "date-placeholder": !item.value }]' class="input input-date" />
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
          <!-- 单选 -->
          <div class="single-select" v-else-if="item.type === 6">
            <div class="fields">{{ item.name }}<span class="required" v-if="item.required">*</span></div>
            <div :class='[{ "input-error": item.error }]' class="select">
              <div class="single-value" @click.stop="showSingleOptions(item, index)">
                <span v-if="item.value">{{ item.text }}</span>
                <span v-else class="select-placeholder">请选择</span>
              </div>
              <div class="options" v-if="showingOptionIdx === index">
                <div class="option" @click="chooseOptions(opt, item, index)" v-for="opt in item.options">{{ opt.text }}
                </div>
              </div>
            </div>
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
          <!-- 单选框 -->
          <div v-else-if="item.type === 7">
            <div class="fields">{{ item.name }}<span class="required" v-if="item.required">*</span></div>
            <div class="radio-options">
              <div class="radio-item" v-for="opt in item.options" :key="opt.value">
                <label :for="opt.key" class="label">
                  <input type="radio" :id="opt" :name="opt.value" v-model="item.value" :value="opt.value"
                    class="input-radio" />
                  <span :class="['radio-text', { 'choosed-text': item.value == opt.value }]">{{ opt.text }}</span>
                </label>
              </div>
            </div>
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
          <!-- 多选框 -->
          <div v-else-if="item.type === 8">
            <div class="fields">{{ item.name }}<span class="required" v-if="item.required">*</span></div>
            <div class="checkbox-options">
              <div class="checkbox-item" v-for="opt in item.options">
                <label :for="opt" class="label"></label>
                <input type="checkbox" :id="opt" :name="opt.value" v-model="item.value" :value="opt.value"
                  class="input-checkbox" />
                <span :class="['checkbox-text',
                  { 'choosed-text': item.value && item.value.includes(opt.value) }]">{{ opt.text }}</span>
              </div>
            </div>
            <div class="error" v-if="item.error">{{ item.error }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-footer">
      <!-- 协议 -->
      <div class="form-agree" v-if="data.hasAgreement">
        <label for="agree" class="agree-check">
          <input type="checkbox" id="agree" v-model="data.isAgree" name="agree" class="input-checkbox agree-checkbox" />
          <div class="agree-detail">
            <template v-for="item in data.agreement">
              <a class="agree-href" v-if="item.link" :href="item.link">{{ item.text }}</a>
              <span class="agree-text" v-else>{{ item.text }}</span>
            </template>
          </div>
        </label>
      </div>
     <div class="footer-btn">
      <button type="submit" :class='["submit","form-button", { "fit-width": !data.isSkip }]'>提交</button>
      <button type="button" class="skip form-button" @click="handleSkip" v-if="data.isSkip">跳过</button>
     </div>
    </div>
  </form>
</template>

<script>
import MixinInformationForm from './MixinInformationForm';
export default {
  mixins: [MixinInformationForm],
  data() {
    return {
      showingOptionIdx: null,
    };
  },
  mounted() {
    document.addEventListener('click', () => {
      this.showingOptionIdx = null;
    });
  },
  methods: {
    /**
     * 展开下拉单选
     * @param {*} item
     * @param {*} index
     */
    showSingleOptions(item, index) {
      this.showingOptionIdx = index;
    },
    /**
     * 下拉单选
     * @param {*} opt
     * @param {*} item
     * @param {*} index
     */
    chooseOptions(opt, item, index) {
      this.data.content[index].value = opt.value;
      this.$set(this.data.content[index], 'text', opt.text);
    },
  },
};
</script>

<style lang="less" scoped>
.information-form {
  padding: 0 16px;

  .declare {
    font-size: 14px;
    line-height: 20px;
    color: #969aaa;
  }

  .form-content {

    .form-content-item {
      margin-top: 16px;

      .item-textarea {
        position: relative;

        .count-num {
          position: absolute;
          bottom: 11px;
          right: 20px;
          font-size: 12px;
          color: rgba(1, 11, 50, 0.41)
        }
      }

      .fields {
        font-size: 14px;
        line-height: 20px;
        color: #000000;
        margin-bottom: 8px;

        .required {
          color: #f75559;
          margin-left: 4px;
        }
      }

      .input,
      .select {
        width: 100%;
        height: 32px;
        border: 1px solid #e0e2e6;
        border-radius: 3px;
        padding-left: 8px;
        box-sizing: border-box;
        outline: none;
        color: #00010A;

        &::placeholder {
          color: #969aaa;
        }

        .select-placeholder {
          color: #969aaa;
        }
      }

      .input-single {
        padding-right: 30px;
      }

      .input-error {
        border: 1px solid #F75559;
      }

      .textarea {
        width: 100%;
        height: 64px;
        padding: 8px 40px 35px 8px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 20px;
        color: #00010A;
        border: 1px solid #e0e2e6;
        border-radius: 3px;
        outline: none;
        resize: none;

        &::placeholder {
          color: #969aaa;
        }

      }

      .radio-options {
        display: flex;
        flex-wrap: wrap;

        .radio-item {
          .label {
            display: flex;
            align-items: center;
          }

          .radio-text {
            font-size: 14px;
            line-height: 20px;
            color: rgba(3, 10, 38, 0.65);
            margin: 0 16px 0 8px;
          }

          .choosed-text {
            color: rgba(0, 1, 10, 0.93);
          }
        }
      }

      .checkbox-options {
        display: flex;
        flex-wrap: wrap;

        .checkbox-item {
          display: flex;
          align-items: center;
          position: relative;

          .input-checkbox {
            width: 16px;
            height: 16px;
            border-radius: 16px;
          }

          .checkbox-text {
            font-size: 14px;
            line-height: 20px;
            color: rgba(3, 10, 38, 0.65);
            margin: 0 24px 0 8px;
          }

          .choosed-text {
            color: rgba(0, 1, 10, 0.93);
          }
        }
      }

      .error {
        color: #F75559;
        font-size: 12px;
        line-height: 16px;
        margin-top: 8px;
        /* 133.333% */
      }

      .input-date {
        position: relative;
      }

      .input-date::after {
        content: url(./assets/calendar.svg);
        position: absolute;
        display: inline-block;
        width: 21px;
        background: #FFFFFF;
        right: 0;
        height: 30px;
        line-height: 30px;
        pointer-events: none;
        box-sizing: border-box;
        padding-top: 2px;
      }

      .date-placeholder::before {
        content: '请选择';
        display: inline-block;
        background: #FFFFFF;
        width: 100px;
        height: 30px;
        position: absolute;
        left: 8px;
        line-height: 32px;
        color: #c9cbd3;
      }

      .input-date::-webkit-calendar-picker-indicator {
        position: absolute;
        right: 0;
        padding-left: 100%;
      }

      input[type=number]::-webkit-inner-spin-button,
      input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type=number] {
        -moz-appearance: textfield;
      }


      .single-select {
        .select {
          position: relative;
          padding-left: 8px;
          line-height: 32px;

          .options {
            width: 100%;
            position: absolute;
            background: #FFF;
            left: 0;
            top: 31px;
            box-sizing: border-box;
            font-size: 14px;
            padding: 8px;
            max-height: 200px;
            overflow-y: scroll;
            line-height: 20px;
            border-radius: 3px;
            box-shadow: 0px 6px 12px 0px rgba(18, 19, 25, 0.12), 0px 0px 4px 0px rgba(18, 19, 25, 0.08),
              0px 0px 1px 0px rgba(18, 19, 25, 0.08);
            border: 0.5px solid rgba(17, 32, 70, 0.13);
            z-index: 1;
          }

          .option {
            padding: 4px 0;
          }

          .option:hover {
            background: rgba(36, 56, 97, 0.05);
          }

          .single-value {
            width: 100%;
            height: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .select-placeholder {
            color: #c9cbd3;
          }
        }

        .select::after {
          content: '';
          border-left: 1px solid #8b91a1;
          border-bottom: 1px solid #8b91a1;
          height: 6px;
          width: 6px;
          transform: translate(2px, -2px) rotate(-45deg);
          border-right: 1px solid transparent;
          border-top: 1px solid transparent;
          display: inline-block;
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
  }

  .form-agree {
    .agree-check {
      display: flex;
      align-items: center;
      font-size: 14px;
      line-height: 20px;

      .input-checkbox {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .agree-text {
        color: rgba(1,11,50,0.41);
      }
      .agree-href {
        color: #4A70FF;
      }
      .agree-detail {
        flex:1;
      }
    }

    .agree-checkbox {
      margin-right: 8px;
    }
  }

  .form-footer {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 16px;
    box-sizing: border-box;
    background: #FFF;


    .submit {
      height: 32px;
      color: #ffffff;
      background: @primary;
      border: 1px solid @primary;
      cursor: pointer;
      border-radius: 3px;
      padding: 6px 16px;
      box-sizing: border-box;
    }
    .form-button {
      flex: 1;
    }
    .fit-width {
      width: 100%;
    }

    .skip {
      padding: 6px 16px;
      box-sizing: border-box;
      color: #11121b;
      margin-left: 8px;
      background-color: #fff;
      border: 1px solid #e0e2e6;
      border-radius: 3px;
    }
    .footer-btn {
      display: flex;
      margin-top: 8px;
      justify-content: center;
    }
  }


  .input-line {
    position: relative;
  }

  .clear-btn {
    display: inline-block;
    width: 16px;
    height: 16px;
    right: 10px;
    top: 35px;
    position: absolute;
    background: url(./assets/error.svg);
    z-index: 100;
  }
}
.im-not-in-frame {
  .bottom-popup {
    .information-form .form-footer {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }
}
</style>
